import type { Sticker } from "../api/StickersAPI"

export function renderStickerCard(sticker: Sticker): HTMLElement {

  const discount = Math.round(
  (1 - sticker.discounted_price_uah / sticker.full_price_uah) * 100
  )
  const card = document.createElement("div")
  card.className = "sticker-card"

  card.innerHTML = `

    <h3 class="sticker-title">
      ${sticker.title}
    </h3>

      <div class="sticker-description">
        ${sticker.description}
      </div>

      <div class="sticker-spacer"></div>

      <div class="price-block">

          <div class="price-full">
            ${sticker.full_price_uah} грн
          </div>

          <div class="price-discount">

            ${sticker.discounted_price_uah} грн

            <span class="discount-badge">
              -${discount}%
            </span>

          </div>

        </div>

    <button class="subscribe-button">
      ${sticker.payment_description_uah}
    </button>

  `

  const button = card.querySelector("button")!

  button.addEventListener("click", () => {

    window.location.href =
      `https://app.deutsch.bezbolu.pro/?auth&sticker=${sticker.sticker_id}`

  })

  return card
}